/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unknown-property */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { GatsbyImage } from 'gatsby-plugin-image'
import { jsx } from 'theme-ui'
import PacManBottom from './adornments'
import { Box, Flex, Heading, Html } from './elements'
import OwensCorning from './OwensCorning'
import Sidebar from './sidebar'
import { GradiantBox } from '../templates/Banner/Banner.styles'

const BoxStyled1 = styled(Box)`
  display: none;
  @media (min-width: 992px) {
    display: block;
    width: 25%;
    margin-right: 5%;
  }
`
const BoxStyled2 = styled(Box)`
  width: 100%;
  box-styled: border-box;
  padding: 0 8px;
  @media (min-width: 992px) {
    width: 70%;
  }
`
export const SubpageHeader = ({ ...props }) => {
  return (
    <div
      css={css`
        display: grid;
      `}
    >
      <GatsbyImage
        alt=""
        css={css`
          grid-area: 1/1;
        `}
        image={props.interiorHeroImage.localFile.childImageSharp.gatsbyImageData}
        sx={{
          position: 'relative',
          height: 538,
          maxHeight: '50vh',
          pb: 114,
          flexDirection: 'column',
          justifyContent: 'flex-end',
          display: 'flex',
          alignItems: 'center',
          color: 'white',
          overflow: 'hidden',
        }}
      />
      <div
        css={css`
          grid-area: 1/1;
          position: relative;
        `}
      >
        <Heading fontSize={[5, 6, 8]}>{props.headerText}</Heading>
        <Heading sx={{ my: 3, fontSize: [3, 4] }}>{props.subHeading}</Heading>

        <GradiantBox
          width="100%"
          height="44%"
          sx={{ position: 'absolute', bottom: '0', zIndex: -1 }}
        />
        <PacManBottom color="secondary" sx={{ height: '40%', bottom: '-30px', width: '100%' }} />
        <PacManBottom
          sx={{
            height: '28%',
            width: '100%',
          }}
        />
      </div>
    </div>
  )
}

export const SubpageBody = ({ ...props }) => {
  return (
    <Box
      sx={{
        py: [4, 5],
      }}
    >
      <Flex
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          maxWidth: 1200,
          mx: 'auto',
        }}
      >
        <BoxStyled1>
          <Sidebar />
        </BoxStyled1>
        <BoxStyled2>
          <Html html={props.content} />
          {props.title === 'Owens Corning' && <OwensCorning />}
        </BoxStyled2>
      </Flex>
    </Box>
  )
}
